export const employmentFormFilterEN = {
  title: 'Employment form',
  value: {
    ALL: '',
    FULL_TIME: 'Full-time',
    PART_TIME: 'Part-time',
    CONSULTANT: 'Consultant',
    EMPLOYEE: 'Employee',
  },
};

export const EMPLOYMENT_FORM_FILTER_TYPE = {
  ALL: '',
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME',
  CONSULTANT: 'CONSULTANT',
  EMPLOYEE: 'EMPLOYEE',
} as const;

export const EMPLOYMENT_FORM_FILTER_TYPE_VALUES = [
  'FULL_TIME',
  'PART_TIME',
  'CONSULTANT',
  'EMPLOYEE',
] as const;

export type EmploymentFormFilterType = typeof EMPLOYMENT_FORM_FILTER_TYPE;
export type EmploymentFormFilterKeys = keyof EmploymentFormFilterType;
export type EmploymentFormFilter =
  EmploymentFormFilterType[EmploymentFormFilterKeys];
export type EmploymentFormFilterSingular =
  (typeof EMPLOYMENT_FORM_FILTER_TYPE_VALUES)[number];
